import { useCallback, useState } from "react";

import { type PageTarget } from "./page_tag";

type ReportFiles = ReadonlyArray<{ id: string }>;

export const isReportFile = (files: ReportFiles, documentId: string) =>
  files.some((file) => file.id === documentId);

// The report file the assistant is reading or searched, if any. Its reads of
// the case's records never move the report pane.
export const followedReportFile = (
  files: ReportFiles,
  documentIds: ReadonlyArray<string | null | undefined>,
) =>
  documentIds.find(
    (documentId): documentId is string =>
      typeof documentId === "string" && isReportFile(files, documentId),
  );

// The page a tag opened. A report page switches the pane to its file; a
// records page has no file there, so it opens over the chat.
export const useReportPageTarget = (
  files: ReportFiles,
  setFileId: (documentId: string) => void,
) => {
  const [target, setTarget] = useState<PageTarget | null>(null);
  const openPage = useCallback(
    (next: PageTarget) => {
      if (isReportFile(files, next.documentId)) setFileId(next.documentId);
      setTarget(next);
    },
    [files, setFileId],
  );
  const closePage = useCallback(() => setTarget(null), []);
  const recordsPage =
    target !== null && !isReportFile(files, target.documentId);

  return { target, recordsPage, openPage, closePage } as const;
};
